/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_SourcesInputs */

const en_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const de_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellen`)
};

const fr_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const es_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes`)
};

const it_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonti`)
};

const nl_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronnen`)
};

const pl_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródła`)
};

const fi_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähteet`)
};

const da_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilder`)
};

const sv_jobs_search_criteria_label_sources = /** @type {(inputs: Jobs_Search_Criteria_Label_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Källor`)
};

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Jobs_Search_Criteria_Label_SourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_sources = /** @type {((inputs?: Jobs_Search_Criteria_Label_SourcesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_SourcesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_sources(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_sources(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_sources(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_sources(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_sources(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_sources(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_sources(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_sources(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_sources(inputs)
	return en_jobs_search_criteria_label_sources(inputs)
});